import React, { Component } from 'react';
import 'core-js';

export default class BudgetTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tableStructure: [],
      tableData: []
    }
  }

  componentDidMount() {
    if (this.props.tableData !== undefined && this.props.tableStructure !== undefined) {
      this.setState({
        tableStructure: this.props.tableStructure,
        tableData: this.props.tableData
      });
    }
    console.log(this.props.tableData);
    console.log(this.props.tableStructure);
  }

  render() {
    let style = {
      color: 'white',
      height: '100%',
      width: '100%',
    };
    let tableHeadStyle = {
      textDecoration: 'underline'
    };
    let tableBodyStyle = {
      textAlign: 'center',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '5px',
    };
    return (
      < table style={style}>
        <thead style={tableHeadStyle}>
          <tr>
            {getTableHead(this.state.tableStructure)}
          </tr>
        </thead>
        <tbody style={tableBodyStyle}>
          {getTableEntryContent(this.state.tableData, [...this.state.tableStructure])}
        </tbody>
      </table >
    );
  }
}
// displayCurrency(this.state.amount, 'EUR', 'de-DE')
function displayCurrency(number, curr, locale) {
  if (locale === undefined) {
    locale = 'en-US';
  }
  if (curr === undefined) {
    curr = 'USD';
  }
  var formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: curr,
  });

  return formatter.format(number);
}
function getTableHead(structure) {
  let tableHead = [];
  structure.forEach(struct => {
    let name = struct.name;
    let i = struct.id;
    tableHead.push(<th key={i}> {name} </th>);
  });
  return tableHead;
}
function getTableEntryContent(data, structureList) {
  let iStructureList = [];
  structureList.forEach(s => {
    iStructureList.push(s.id);
  });
  let tableBody = [];
  let elementId = 0;
  data.forEach(dataElem => {
    elementId++;
    let tableBodyEntry = [];
    let elementData = new Map(dataElem.entryData);
    iStructureList.forEach(structEntry => {
      elementId++;
      if (structEntry === 'budget' || structEntry === 'gebunden' || structEntry === 'ausgezahlt' || structEntry === 'mittelver' || structEntry === 'mittelvor' || structEntry === 'mittelfre') {
        tableBodyEntry.push(<td key={elementId} style={{ textAlign: 'right' }}>{displayCurrency(elementData.get(structEntry), 'EUR', 'de-DE')}</td>);
      } else {
        tableBodyEntry.push(<td key={elementId}>{elementData.get(structEntry)}</td>);
      }
    });
    tableBodyEntry = <tr key={elementId}>{tableBodyEntry}</tr>;
    tableBody.push(tableBodyEntry);
  });
  return tableBody;
}



// WEBPACK FOOTER //
// ./src/component/BudgetTable.js